export const getSpecialOffers = (specialOffers) => {
  let specialOfferResults = specialOffers
    .map((offer) => {
      let offerObj = {};
      offerObj.specialOffer = offer.excerpt;
      offerObj._type = offer.assignedCptType;
      offerObj.enabled = offer.enabled;
      if (offer.assignedCptType === "attraction") {
        offerObj._id = offer.assignedCptAttraction._id;
        offerObj._type = offer.assignedCptAttraction._type;
        offerObj.title = offer.assignedCptAttraction.title;
        offerObj.slug = offer.assignedCptAttraction.slug;
        offerObj.excerpt = offer.assignedCptAttraction.excerpt;
        offerObj.thumbnail = offer.assignedCptAttraction.thumbnail;
        offerObj.city = offer.assignedCptAttraction.city;
        offerObj.country = offer.assignedCptAttraction.country;
      } else if (offer.assignedCptType === "culturalTour") {
        offerObj._id = offer.assignedCptCulturalTour._id;
        offerObj._type = offer.assignedCptCulturalTour._type;
        offerObj.title = offer.assignedCptCulturalTour.title;
        offerObj.slug = offer.assignedCptCulturalTour.slug;
        offerObj.excerpt = offer.assignedCptCulturalTour.excerpt;
        offerObj.thumbnail = offer.assignedCptCulturalTour.thumbnail;
        // offerObj.departureDates = offer.assignedCptCulturalTour.departureDates;
        offerObj.includedCities = offer.assignedCptCulturalTour.includedCities;
        offerObj.includes = offer.assignedCptCulturalTour.includes;
        offerObj.themeTags = offer.assignedCptCulturalTour.themeTags;
      } else if (offer.assignedCptType === "hotelBreak") {
        offerObj._id = offer.assignedCptHotelBreak._id;
        offerObj._type = offer.assignedCptHotelBreak._type;
        offerObj.title = offer.assignedCptHotelBreak.title;
        offerObj.highlyRecommended = offer.assignedCptHotelBreak.highlyRecommended;
        offerObj.excerpt = offer.assignedCptHotelBreak.excerpt;
        offerObj.slug = offer.assignedCptHotelBreak.slug;
        offerObj.thumbnail = offer.assignedCptHotelBreak.thumbnail;
        offerObj.images = offer.assignedCptHotelBreak.images;
        offerObj.hotelType = offer.assignedCptHotelBreak.hotelType;
        offerObj.starRating = offer.assignedCptHotelBreak.starRating;
        offerObj.includes = offer.assignedCptHotelBreak.includes;
        offerObj.city = offer.assignedCptHotelBreak.city;
        offerObj.country = offer.assignedCptHotelBreak.country;
        offerObj.region = offer.assignedCptHotelBreak.region;
      } else if (offer.assignedCptType === "opera") {
        offerObj._id = offer.assignedCptOpera._id;
        offerObj._type = offer.assignedCptOpera._type;
        offerObj.title = offer.assignedCptOpera.title;
        offerObj.slug = offer.assignedCptOpera.slug;
        offerObj.excerpt = offer.assignedCptOpera.excerpt;
        offerObj.thumbnail = offer.assignedCptOpera.thumbnail;
        offerObj.city = offer.assignedCptOpera.city;
        offerObj.country = offer.assignedCptOpera.country;
        offerObj.includes = offer.assignedCptOpera.includes;
        offerObj.themeTags = offer.assignedCptOpera.themeTags;
      } else if (offer.assignedCptType === "railJourney") {
        offerObj._id = offer.assignedCptRailJourney._id;
        offerObj._type = offer.assignedCptRailJourney._type;
        offerObj.title = offer.assignedCptRailJourney.title;
        offerObj.slug = offer.assignedCptRailJourney.slug;
        offerObj.excerpt = offer.assignedCptRailJourney.excerpt;
        offerObj.thumbnail = offer.assignedCptRailJourney.thumbnail;
        offerObj.includedCities = offer.assignedCptRailJourney.includedCities;
        offerObj.includes = offer.assignedCptRailJourney.includes;
        offerObj.themeTags = offer.assignedCptRailJourney.themeTags;
      } else if (offer.assignedCptType === "tailorMadeHoliday") {
        offerObj._id = offer.assignedCptTailorMadeHoliday._id;
        offerObj._type = offer.assignedCptTailorMadeHoliday._type;
        offerObj.title = offer.assignedCptTailorMadeHoliday.title;
        offerObj.excerpt = offer.assignedCptTailorMadeHoliday.excerpt;
        offerObj.slug = offer.assignedCptTailorMadeHoliday.slug;
        offerObj.thumbnail = offer.assignedCptTailorMadeHoliday.thumbnail;
        offerObj.includes = offer.assignedCptTailorMadeHoliday.includes;
        offerObj.includedCities =
          offer.assignedCptTailorMadeHoliday.includedCities;
        offerObj.themeTags = offer.assignedCptTailorMadeHoliday.themeTags;
      }
      return offerObj;
    })
    .filter((offer) => offer.enabled);

  return specialOfferResults;
};
